import { useCallback, useEffect, useState } from 'react';

const getElement = () => document.querySelector('.SiteNav');

export const useNavHeight = () => {
  const [height, setHeight] = useState<undefined | number>(undefined);

  const getNavHeight = useCallback((entries: ResizeObserverEntry[]) => {
    const [
      {
        contentRect: { height }
      }
    ] = entries;

    setHeight(height);
  }, []);

  useEffect(() => {
    const element = getElement();

    if (!element) return;

    const resizeObserver = new ResizeObserver(getNavHeight);

    resizeObserver.observe(element);

    return () => resizeObserver.unobserve(element);
  }, [getNavHeight]);

  return { height };
};
